import React, { useState, useEffect } from 'react';
import SkeletonImage from '../Skeleton/skeleton-image-component';
import { isVideoUrl } from '../../Services/ApiService';
import MediaComponent from '../Media/media-component';

const CarouselFadeComponent = ({ images = [], duration = 4000, isBackground = false }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const validImages = images?.filter(Boolean) || [];

    useEffect(() => {
        if (validImages.length <= 1) return;
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % validImages.length);
        }, duration);
        return () => clearInterval(interval);
    }, [validImages.length, duration]);

    const handleDotClick = (index) => {
        setCurrentIndex(index);
    };

    if (!validImages || validImages.length === 0) {
        return (
            <div className="w-full h-full bg-primary-900 flex items-center justify-center">
                <SkeletonImage />
            </div>
        );
    }

    // Dynamic classes: Full bleed absolute for landing background, rounded box for inner pages
    const containerClasses = isBackground
        ? "absolute inset-0 w-full h-full overflow-hidden bg-primary-950"
        : "relative w-full h-[50vh] min-h-[400px] md:h-[700px] overflow-hidden rounded-[30px] shadow-2xl bg-primary-950";

    return (
        <div className={containerClasses}>
            
            {validImages.map((img, index) => {
                const isCurrent = index === currentIndex;
                const rawSrc = typeof img === 'string' ? img : (img?.image || img?.src || img?.media || img?.url);
                const src = typeof rawSrc === 'string' ? rawSrc : '';
                
                return (
                    <div 
                        key={index}
                        className={`absolute inset-0 w-full h-full transition-all duration-1000 ease-in-out transform ${
                            isCurrent ? 'opacity-100 scale-100 z-10' : 'opacity-0 scale-105 z-0'
                        }`}
                    >
                        {src && (
                            <MediaComponent
                                src={src}
                                alt={`Slide ${index + 1}`}
                                objectFit="cover"
                                useSekeleton={false}
                                eager={index === 0}
                                quality={70}
                                wrapperClassName="w-full h-full"
                                className="w-full h-full object-cover object-center"
                            />
                        )}
                    </div>
                );
            })}

            {/* Pagination Dots - Hidden if used as background */}
            {!isBackground && validImages.length > 1 && (
                <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-3 z-30 pointer-events-auto p-3 rounded-full bg-primary-950/40 backdrop-blur-md border border-white/10">
                    {validImages.map((_, i) => (
                        <button
                            key={i}
                            onClick={() => handleDotClick(i)}
                            aria-label={`Go to slide ${i + 1}`}
                            className={`w-3 h-3 rounded-full transition-all duration-300 ${
                                i === currentIndex
                                    ? 'bg-secondary-500 scale-125'
                                    : 'bg-white/50 hover:bg-white'
                            }`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default CarouselFadeComponent;